export default __webpack_public_path__ + "static/realWorldImg2-b096b1e68e0fae2fe004b73716b29e5a.webp";